/* Farishe — Atelier */
(function () {
  // mobile drawer
  var burger = document.querySelector('[data-drawer-open]');
  var drawer = document.getElementById('nav-drawer');
  var scrim = document.querySelector('[data-scrim]');
  function setDrawer(on) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', on);
    if (scrim) scrim.classList.toggle('is-open', on);
    document.body.style.overflow = on ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { setDrawer(true); });
  if (scrim) scrim.addEventListener('click', function () { setDrawer(false); });
  var dclose = document.querySelector('[data-drawer-close]');
  if (dclose) dclose.addEventListener('click', function () { setDrawer(false); });

  // hero slideshow
  document.querySelectorAll('[data-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.hero__slide');
    if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-on'); return; }
    var dots = hero.querySelectorAll('.hero__dots button');
    var i = 0, timer = null;
    var speed = parseInt(hero.getAttribute('data-speed') || '6', 10) * 1000;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function play() { clearInterval(timer); timer = setInterval(function () { show(i + 1); }, speed); }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { show(k); play(); }); });
    show(0);
    if (hero.getAttribute('data-autoplay') === 'true') play();
  });

  // product gallery: thumbnail rail + main stage
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var stage = gal.querySelector('[data-stage]');
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('[data-thumb]'));
    var counter = gal.querySelector('[data-stage-index]');
    if (!stage || thumbs.length < 2) return;
    var i = 0;
    function show(n) {
      i = (n + thumbs.length) % thumbs.length;
      var t = thumbs[i];
      stage.src = t.getAttribute('data-full');
      stage.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (x, k) { x.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = i + 1;
      if (t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var prev = gal.querySelector('[data-stage-prev]');
    var next = gal.querySelector('[data-stage-next]');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(i - 1);
      if (e.key === 'ArrowRight') show(i + 1);
    });
    // swipe on touch
    var x0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) show(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
  });

  // product variants
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants = JSON.parse(data.textContent || '[]');
    var idField = form.querySelector('[name="id"]');
    var priceEl = form.querySelector('[data-price]');
    var btn = form.querySelector('[data-add]');
    function current() {
      var chosen = [];
      form.querySelectorAll('[data-opt]').forEach(function (group) {
        var sel = group.querySelector('input:checked');
        if (sel) chosen.push(sel.value);
      });
      return variants.filter(function (v) {
        return chosen.every(function (val, idx) { return v.options[idx] === val; });
      })[0];
    }
    function sync() {
      var v = current();
      if (!v) {
        if (btn) { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Unavailable'; }
        return;
      }
      if (idField) idField.value = v.id;
      if (priceEl && v.price_html) priceEl.innerHTML = v.price_html;
      if (btn) {
        if (v.available) { btn.removeAttribute('disabled'); btn.textContent = btn.getAttribute('data-label') || 'Add to cart'; }
        else { btn.setAttribute('disabled', 'disabled'); btn.textContent = 'Sold out'; }
      }
    }
    form.addEventListener('change', sync);
    sync();
  });

  // accordions: keep one open
  document.querySelectorAll('[data-acc-group]').forEach(function (g) {
    var items = g.querySelectorAll('details');
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
  });
})();

// footer columns fold up on phones
(function () {
  var mq = window.matchMedia('(max-width:759px)');
  function wire(col) {
    var h = col.querySelector('[data-ft-toggle]');
    if (!h || h.dataset.wired) return;
    h.dataset.wired = '1';
    function toggle() { if (mq.matches) col.classList.toggle('is-open'); }
    h.addEventListener('click', toggle);
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  }
  document.querySelectorAll('[data-ft-col]').forEach(wire);
  mq.addEventListener('change', function () {
    if (!mq.matches) document.querySelectorAll('[data-ft-col]').forEach(function (c) { c.classList.remove('is-open'); });
  });
})();
